import { render, staticRenderFns } from "./UiModalView.vue?vue&type=template&id=05ee578a&scoped=true&"
import script from "./UiModalView.vue?vue&type=script&lang=js&"
export * from "./UiModalView.vue?vue&type=script&lang=js&"
import style0 from "./UiModalView.vue?vue&type=style&index=0&lang=css&"
import style1 from "./UiModalView.vue?vue&type=style&index=1&id=05ee578a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ee578a",
  null
  
)

export default component.exports